<script setup lang="ts">
import {Dialog, DialogContent, DialogDescription, DialogTitle} from "@/core/components/ui/dialog";
import {GeneratedReport, ObjectSchema, ObjectValue} from "@/generated-report/interfaces";
import GeneratingStep from "@/generated-report/components/dialog/GeneratingStep.vue";
import EditStep from "@/generated-report/components/dialog/EditStep.vue";
import {BackingGenerationState} from "@/backing/interfaces/backing";
import {VisuallyHidden} from "reka-ui";
import {CloudAlert} from "@lucide/vue";

defineProps<{
    state: BackingGenerationState;
    report: { data: GeneratedReport; schema: ObjectSchema } | null;
    loading?: boolean;
}>();

const emits = defineEmits<{
    (e: 'save', data: ObjectValue, report: GeneratedReport): void;
}>();

const open = defineModel<boolean>("open", {required: true});
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent
      class="max-w-4xl max-h-[90vh] flex flex-col gap-2"
      aria-describedby="content-generated-report-dialog"
      hide-close
      @interact-outside="(e) => e.preventDefault()"
    >
      <VisuallyHidden>
        <DialogTitle>
          Rapport généré
        </DialogTitle>
        <DialogDescription>
          <span id="content-generated-report-dialog">
            Vous pouvez visualiser et éditer le rapport généré avant impression.
          </span>
        </DialogDescription>
      </VisuallyHidden>
      <GeneratingStep v-if="state === 'generating'" />
      <EditStep
        v-if="report?.data.status === 'completed' && state === 'generated'"
        class="flex-1"
        :report="report.data"
        :schema="report.schema"
        :loading="loading"
        @save="emits('save', $event, report.data)"
      />
      <div
        v-if="(state === 'error' || report?.data.status === 'failed')"
        class="p-6 flex flex-col items-center"
      >
        <CloudAlert class="size-[300px] text-red" />
        <p>
          Une erreur est survenue lors de la génération du rapport. Veuillez réessayer.
        </p>
      </div>
    </DialogContent>
  </Dialog>
</template>

<style scoped>

</style>
